module.exports = __webpack_public_path__ + "img/huaweiyun.71e3d79a.jpg";